import type { ChildrenWaiting } from './executionStatus';

// Derived beside the rest of a task's run state, which needs it; re-exported
// so the words and the fact are found in one place.
export { waitingOnChildren, type ChildrenWaiting } from './executionStatus';

/** "Waiting on 3 of 4 · Design review" — the card, the drawer and the run page. */
export function waitingOnChildrenLabel(waiting: ChildrenWaiting): string {
  const count = `Waiting on ${String(waiting.open)} of ${String(waiting.total)}`;
  return waiting.workflowName ? `${count} · ${waiting.workflowName}` : count;
}

/** Stop, on a parent waiting on its children: it stops the waiting, not them. */
export const STOP_WAITING = 'Stop waiting';

/** Said once it has stopped (spec 097 FR-012: no cascading stop). */
export const STOP_WAITING_NOTE = 'The tasks it started keep going.';
